module.exports = __webpack_public_path__ + "static/Pech@2x.5605c9ff.png";